module.exports = __webpack_public_path__ + "img/focus-icon.5121eecd.png";